import { defineDirective, FieldsMap, IOmniaCommandGroup, IOmniaShell, layers } from "../omnia"
import { IFieldsEditService, IFieldsModuleContext, IFieldsService } from "../types"

import map = omnia.map;

export function createMapView(): ng.IDirective {

    return defineDirective(ViewCtrl, "app/fields/map/view.html", {
        context: "="
    });

};

export class ViewCtrl {

    static $inject = ["$scope", "OmniaFieldsService", "OmniaShell", "OmniaFieldsEditService"];

    private context: IFieldsModuleContext;

    private fieldsMap: FieldsMap;

    private commandsGroups: IOmniaCommandGroup[];

    constructor(private $scope: ng.IScope, private svc: IFieldsService, private shell: IOmniaShell, private editSvc: IFieldsEditService) {

    }

    $onInit() {

        let unbind = this.$scope.$watch("vm.svc.mapView", value => {

            if (value) {

                unbind();
                unbind = null;

                this.setup();

            }

        });

    }

    private setup() {

        this.fieldsMap = this.context.map;
        this.fieldsMap.addTooltipProvider(t => this.getTooltip(t));

    }

    get isActive(): boolean {

        return this.context && this.context.mapView;

    }

    private getTooltip(tooltip: map.IMapTooltip): boolean {

        if (!tooltip) return false;
        if (!tooltip.feature) return false;

        let layer = tooltip.feature.get("layer");

        if (((layer instanceof layers.FieldsLayer) || (layer instanceof layers.CroppingLayer)) && !this.editSvc.isEditing) {

            if (tooltip.contextMenu) {
                tooltip.context = this.context;
                tooltip.template = "app/fields/map/contextMenu.html";
                return true;
            }

        }

    }

}
